import { render, staticRenderFns } from "./CancelAccountNote.vue?vue&type=template&id=97cb36f6&"
import script from "./CancelAccountNote.vue?vue&type=script&lang=js&"
export * from "./CancelAccountNote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports